module.exports = __webpack_public_path__ + "static/media/building.63774139.svg";